<template>
  <!-- Orders Status -->
  <div class="card bg-darkgrey">
    <div id="stats">
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.processing')}}: <span class="pull-right color-white" >{{ newCount.processing }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.processing_ready')}}: <span class="pull-right color-white" >{{ newCount.processingReady }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.processing_not')}}: <span class="pull-right color-white" >{{ newCount.processingNot }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.processing_missing')}}: <span class="pull-right color-white" >{{ newCount.processingMissing }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.dispatch')}}: <span class="pull-right color-white" >{{ newCount.dispatch }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.pick')}}: <span class="pull-right color-white" >{{ newCount.pick }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.transit')}}: <span class="pull-right color-white" >{{ newCount.transit }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.delivered')}}: <span class="pull-right color-white" >{{ newCount.drop }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.transferred')}}: <span class="pull-right color-white" >{{ newCount.transfer }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.rejected')}}: <span class="pull-right color-white" >{{ newCount.reject }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.waiting')}}: <span class="pull-right color-white" >{{ newCount.waiting }}</span></p>
      </div>
      <div class="col-6 col-lg-3">
        <p class="my-3">{{$t('OrderCurrent.stats.inspection')}}: <span class="pull-right color-white" >{{ newCount.inspection }}</span></p>
      </div>
    </div>
  </div>
</template> 

<script>
export default {
  data () {
    return {
      processingState: {
        processing: 'Processing',
        not: 'Not',
        ready: 'Ready',
        missing: 'Missing'
      }
    }
  },
  props: {
    filterResults: Array,
    processedArray: Array
  },

  methods: {
    /** To add counter for processing orders if:
     * Survey answered
     * || Survey answered and car is ready
     * || Survey answered and car is not ready
     * || Survey answered and car is not ready but it has now passed the ready date the user entered in the survey
     * || Survey not answered
     */
    setOtherProcessing (order) {
      let responseString = ''

      if (order.survey) { // If order has a survey
        for (const key in order.survey) {
          if (Object.hasOwnProperty.call(order.survey, key)) {
            order.survey[key].forEach(question => {
              if (question.id === '1') { // To check the first questions' answer
                if (question.answer === true) responseString = this.processingState.ready // Car ready
                else if (question.answer === false) {
                  const questionWithTimestamp = order.survey[key].find(question => question.id === '1.1')
                  let time = this.getTimestamp(questionWithTimestamp.answer)
                  if (time > Date.now()) {
                    responseString = this.processingState.not // Car not ready
                  } else if (time < Date.now()) {
                    responseString = this.processingState.ready // Car ready
                  }
                }
                return // Stop cycling through questions for the order
              }
            })
          }
        }
      } else responseString = this.processingState.missing // Missing survey

      return responseString
    },

    getTimestamp (receivedDate) {
      let timestamp = Date.parse(receivedDate)
      return timestamp
    },

    countNewNote (processedArray) {
      let count = 0

      processedArray.forEach((o) => {
        if (o.read === false) count++
      })

      return count
    },

    countNewDate (processedArray) {
      let count = 0

      processedArray.forEach((o) => {
        if (o.datePromis !== null && o.datePromis !== '' && o.datePromis !== undefined) {
          var fdate = new Date(o.datePromis)
          var today = new Date()
          today.setHours(0, 0, 0, 0)
          if (fdate <= today) {
            count++
          }
        }
      })

      return count
    }

  },
  computed: {
    newCount () {
      let count = {
        processing: 0,
        processingReady: 0,
        processingNot: 0,
        processingMissing: 0,
        dispatch: 0,
        pick: 0,
        transit: 0,
        drop: 0,
        transfer: 0,
        reject: 0,
        waiting: 0,
        newNote: 0,
        newDate: 0,
        inspection: 0
      }

      count.newNote = this.countNewNote(this.processedArray)

      count.newDate = this.countNewDate(this.processedArray)

      this.filterResults.forEach((o) => {
        if (o.status === 'Processing') {
          count.processing++

          switch (this.setOtherProcessing(o)) {
            case this.processingState.ready:
              count.processingReady++
              break

            case this.processingState.not:
              count.processingNot++
              break

            case this.processingState.missing:
              count.processingMissing++
              break

            default:
              console.log('What?')
              break
          }
        }
        if (o.status === 'Dispatch') count.dispatch++
        if (o.status === 'Pick') count.pick++
        if (o.status === 'Transit') count.transit++
        if (o.status === 'Drop') count.drop++
        if (o.status === 'Transférée') count.transfer++
        if (o.status === 'Reject') count.reject++
        if (o.status === 'Inspection') count.inspection++
        if (o.status === 'Attente') count.waiting++
      })

      return count
    }
  }
}
</script>
